import { openNotificationWithIcon } from 'components/common/Notification';

export const InterceptError = (message: string, description?: string) =>
    openNotificationWithIcon({ type: 'error', message, description });

export const InterceptSuccess = (message: string, description?: string) =>
    openNotificationWithIcon({ type: 'success', message, description });
